/**
 * !!!IMPORTANT!!!
 * Please do not add any new colors without an agreement with our designer.
 * Right now, theme includes all the colors from Figma, so unless it was added
 * to the main Colors scheme in Figma, you must only use colors that are defined in here.
 */

import { PaletteOptions } from '@mui/material_v7/styles/createPalette';

const colors: PaletteOptions = {
  // purple
  primary: {
    600: '#5449D2',
    500: '#695EE4',
    400: '#9E96ED',
    300: '#CECBF6',
    200: '#EFEEFC',
  },
  // purpleGrey
  secondary: {
    main: '#F', // to hide MUI compatibility error
    700: '#150F57',
    600: '#C5C1F2',
    500: '#DEDCF9',
    400: '#F8F8FF',
    300: '#F3F4F8',
  },
  grey: {
    black: '#1B1B1B',
    900: '#212121',
    800: '#424242',
    700: '#616161',
    600: '#757575',
    500: '#9E9E9E',
    400: '#BDBDBD',
    300: '#E0E0E0',
    200: '#EEEEEE',
    100: '#FAFAFA',
    white: '#FFFFFF',
  },
  // green
  success: {
    600: '#2E7D32',
    500: '#4CAF50',
    400: '#C8E6C9',
    300: '#E8F5E9',
  },
  // orange
  warning: {
    600: '#EF6C00',
    500: '#FF9800',
    400: '#FFE0B2',
    300: '#FFF3E0',
  },
  // yellow
  warning2: {
    600: '#FFD600',
    500: '#FFF9C4',
  },
  // red
  error: {
    600: '#C62828',
    500: '#D32F2F',
    400: '#EF5350',
    300: '#FFCDD2',
    200: '#FFEBEE',
  },
  // tech marketplace (received from backend)
  other: {
    standardSupport: '#09deff',
    premiumSupport: '#116ba7',
    repairDepot: '#f2c566',
    teleTech: '#be68eb',
  },
};

// Partners WhiteLabel - should replace 'secondary';
// see 'primaryColorsWL' and 'secondaryColorsWL'(blueGrey) implementation
export const wlSecondary = {
  700: '#31323A',
  600: '#C0C6D0',
  500: '#E4E6EB',
  400: '#F7F8F8',
  300: '#F7F8F8',
};

export default colors;
